"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelSEFeatureResponse = void 0;
var ChannelSEFeatureResponse;
(function (ChannelSEFeatureResponse) {
    let type;
    (function (type) {
        type["BOT"] = "bot";
        type["OVERLAY"] = "overlay";
        type["TIPS"] = "tips";
        type["MERCH"] = "merch";
        type["VOD_DYNAMIC_BANNER"] = "vodDynamicBanner";
        type["VOD_DYAMIC_THUMBNAIL"] = "vodDyamicThumbnail";
        type["VOD_SOG"] = "vodSOG";
        type["VOD_DYNAMIC_DESCRIPTION"] = "vodDynamicDescription";
        type["SE_LIVE"] = "seLive";
    })(type = ChannelSEFeatureResponse.type || (ChannelSEFeatureResponse.type = {}));
    let state;
    (function (state) {
        state["ACTIVE"] = "active";
        state["DISABLED"] = "disabled";
    })(state = ChannelSEFeatureResponse.state || (ChannelSEFeatureResponse.state = {}));
})(ChannelSEFeatureResponse = exports.ChannelSEFeatureResponse || (exports.ChannelSEFeatureResponse = {}));
